const WATERFALLS = [
  {
    name: 'Glen Falls',
    description:
      'Glen Falls is one of the most popular waterfalls near Highlands, featuring multiple cascading sections along a scenic forest trail. It\'s a favorite destination for visitors exploring the area.',
  },
  {
    name: 'Dry Falls',
    description:
      'A 75-foot waterfall on the Cullasaja River where visitors can walk directly behind the falls without getting wet. The paved, accessible path leads into a natural stone amphitheater just off US-64.',
  },
  {
    name: 'Bridal Veil Falls',
    description:
      'One of the most accessible waterfalls in the region, Bridal Veil Falls cascades in a graceful curtain along a short, easy path. Located minutes from downtown Highlands and suitable for all ages.',
  },
];

export default function WaterfallsSection() {
  return (
    <section className="bg-[#FAFAF8] py-24 px-6 lg:px-14" id="waterfalls">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <p className="text-[#C9A96E] text-xs tracking-[0.35em] uppercase font-jost mb-4">/ Natural Attractions</p>
          <h2 className="font-cormorant text-5xl md:text-6xl text-[#1A1A18] font-light">
            Waterfalls in <em className="italic">Highlands NC</em>
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div className="rounded-2xl overflow-hidden h-[480px] lg:sticky lg:top-8">
            <img
              src="https://public.readdy.ai/ai/img_res/1bba9d7ac21941fc863e9c589ed4fb29.jpg"
              alt="Waterfall in Highlands North Carolina — cascading falls surrounded by lush forest"
              className="w-full h-full object-cover object-top"
            />
          </div>

          <div className="space-y-8">
            {WATERFALLS.map((wf) => (
              <article key={wf.name} className="bg-white rounded-2xl p-8">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#EDE8E0]">
                    <i className="ri-water-flash-line text-[#2D4A3E] text-sm" />
                  </div>
                  <h3 className="font-cormorant text-2xl text-[#1A1A18] font-medium">{wf.name}</h3>
                </div>
                <p className="text-[#5C5850] font-jost text-sm leading-relaxed">{wf.description}</p>
              </article>
            ))}
          </div>
        </div>

        <div className="mt-12 max-w-2xl mx-auto text-center">
          <p className="text-[#5C5850] font-jost text-sm leading-relaxed">
            Many of the most popular waterfalls in Highlands, North Carolina are located within a short drive of each other, making it easy to explore multiple locations in one day.
          </p>
        </div>
      </div>
    </section>
  );
}
